import { createFileRoute, redirect } from '@tanstack/react-router'
import { bootstrapQueryOptions } from '@/features/bootstrap/api/bootstrap/queries/bootstrap-query'
import {
  getNoWorkspacesEntryRoute,
  shouldRedirectToNoWorkspaceEntry,
} from '@/features/bootstrap/domain/bootstrap-entry'
import {
  getPreferredBootstrapWorkspaceId,
  hasBootstrapWorkspaceId,
} from '@/features/bootstrap/domain/bootstrap-workspaces'
import WorkspaceChatPage from '@/pages/workspace/chat'
import { requireAuthenticated } from '@/shared/lib/route-guards'
import {
  getLastWorkspaceId,
  setLastWorkspaceId,
} from '@/shared/lib/last-workspace'
import { GTM_PRODUCT_SCOPE } from '@/shared/lib/gtm-product-scope'
import { redirectWorkspaceToGtm } from '@/shared/lib/gtm-route-guard'

export const Route = createFileRoute(
  '/$lang/workspace/$workspaceId/chats/$chatId',
)({
  beforeLoad: async ({ context, params }) => {
    if (!GTM_PRODUCT_SCOPE.legacyWorkspaceUi) {
      await redirectWorkspaceToGtm(context, params)
    }
    requireAuthenticated(context, params)
    setLastWorkspaceId(params.workspaceId)

    const bootstrap = await context.queryClient.ensureQueryData(
      bootstrapQueryOptions(),
    )
    if (shouldRedirectToNoWorkspaceEntry(bootstrap)) {
      throw redirect({
        to: getNoWorkspacesEntryRoute(bootstrap),
        params: { lang: params.lang },
        replace: true,
      })
    }

    if (!hasBootstrapWorkspaceId(bootstrap.workspaces, params.workspaceId)) {
      const preferredWorkspaceId = getPreferredBootstrapWorkspaceId(
        bootstrap.workspaces,
        getLastWorkspaceId(),
      )

      if (preferredWorkspaceId) {
        throw redirect({
          to: '/$lang/workspace/$workspaceId',
          params: { lang: params.lang, workspaceId: preferredWorkspaceId },
          replace: true,
        })
      }
    }
  },
  component: WorkspaceChatPage,
  staticData: { layout: 'main' },
})
